import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query AuthorCompleteTrace($id: ID!) {
    authorCompleteTrace(id: $id) {
      id
      acMachineName
      spans {
        id
        name
        data
        response
      }
    }
  }
`;

export const queryAuthorCompleteTrace = (id) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      id,
    },
  }).then(({ data }) => getSingleProp(data));
};
